import { render, staticRenderFns } from "./EmploymentDetails.vue?vue&type=template&id=68368693"
import script from "./EmploymentDetails.vue?vue&type=script&lang=js"
export * from "./EmploymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68368693')) {
      api.createRecord('68368693', component.options)
    } else {
      api.reload('68368693', component.options)
    }
    module.hot.accept("./EmploymentDetails.vue?vue&type=template&id=68368693", function () {
      api.rerender('68368693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/EmploymentDetails/EmploymentDetails.vue"
export default component.exports